import ChatConfigProvider from './ChatConfigProvider'

export default ChatConfigProvider
